export const environment = {
  production: true,
  url_site: 'https://app.aurodata.co/',
  title: 'Prod environment',
  firebase: {
    apiKey: 'AIzaSyDhNwkA_CYrYwR_Mm1itKdV95iW83poOts',
    authDomain: 'auro-builder.firebaseapp.com',
    projectId: 'auro-builder',
    storageBucket: 'auro-builder.appspot.com',
    messagingSenderId: '142452756658',
    appId: '1:142452756658:web:ac04178e81e5859f56b9ab',
    measurementId: 'G-G4G0W46WVD',
  },
  url_api_payment: 'https://prod-api-payu-php.calia.com.co/',
  url_api: 'https://api.aurodata.co/',
    email_team: 'jose.arellano@calia.ai'
};
